import React from 'react'
import { connect } from 'react-redux'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import {
  origins,
  UserClickPayload,
} from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { CancelIcon } from '@chegg-ui/theme'
import { PLAGIARISM_SCROLL_MODAL } from '@chegg-wt/core/state/modals/constants'
import { INLINE_UPLOAD_WIDGET_ID } from '@chegg-wt/core/components/BibliographyContainer'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { closeModal } from '@chegg-wt/core/state/modals/actions'
import { ModalWrapper, DefaultBackdrop, PositioningWrapper } from '../styled'
import { MAIN_FRAME_ID } from '../../AdFrame/testIds'
import { MODAL_CONTENT, CLOSE_BUTTON, GET_STARTED_BUTTON, TITLE_ICON } from './testIds'
import * as Styled from './styled'

const MODAL_WIDTH = '564px'
export const HEADER_OFFSET = 60 + 12
export const ICON_FILENAME = 'writing-check.png'

export const TITLE_TEXT = 'Check your paper for plagiarism errors'
export const SUB_TITLE_TEXT = 'Make sure you didn’t forget a source or cite incorrectly'
export const BUTTON_TEXT = 'Get started'

export const scrollToTarget = async (
  containerSelector: string,
  targetSelector: string,
  behavior: ScrollBehavior = 'smooth'
) => {
  const mainFrame = document.querySelector(containerSelector)
  const uploadWidget = document.querySelector(targetSelector)
  const widgetCoords = uploadWidget.getBoundingClientRect()

  await mainFrame.scrollTo({ top: widgetCoords.top - HEADER_OFFSET, behavior })
  uploadWidget.querySelector('textarea').focus()
}
interface Props {
  closeModal: (name: string) => void
  userClick: (payload: UserClickPayload) => void
}

export const PlagiarismScrollModal: React.FC<Props> = ({ closeModal, userClick }) => {
  const handleCloseModal = () => {
    userClick({ origin: origins.closeModalCheckPaperExitPopup })
    closeModal(PLAGIARISM_SCROLL_MODAL)
  }

  return (
    <ModalWrapper backdrop show renderBackdrop={() => <DefaultBackdrop />}>
      <PositioningWrapper>
        <Styled.ModalContent
          fullMobileModal
          maxWidth={MODAL_WIDTH}
          data-test={MODAL_CONTENT}
        >
          <Styled.CloseButton
            screenReaderOnlyText="close modal"
            onClick={handleCloseModal}
            data-test={CLOSE_BUTTON}
          >
            <CancelIcon size="medium" />
          </Styled.CloseButton>
          <Styled.ContentContainer>
            <Styled.TitleIcon
              src={publicAssetUrl(ICON_FILENAME)}
              data-test={TITLE_ICON}
            />
            <Styled.TextContainer>
              <Styled.TitleText>{TITLE_TEXT}</Styled.TitleText>
              <Styled.SubTitleText>{SUB_TITLE_TEXT}</Styled.SubTitleText>
            </Styled.TextContainer>
            <Styled.GetStartedButton
              onClick={() => {
                userClick({ origin: origins.checkPaperExitPopup })
                closeModal(PLAGIARISM_SCROLL_MODAL)
                scrollToTarget(`#${MAIN_FRAME_ID}`, `#${INLINE_UPLOAD_WIDGET_ID}`)
              }}
              data-test={GET_STARTED_BUTTON}
            >
              {BUTTON_TEXT}
            </Styled.GetStartedButton>
          </Styled.ContentContainer>
        </Styled.ModalContent>
      </PositioningWrapper>
    </ModalWrapper>
  )
}

const mapDispatchToProps = { closeModal, userClick }

export default connect(null, mapDispatchToProps)(PlagiarismScrollModal)
